import React from 'react';
import logo from '../components/images/logo.png'

function Logo() {
  return (
    <div className='logo'>
         <img src={"https://content.acetians.in/uploads/SGMR%20LOGO%20FINAL%20FILE%20PNG.png"} alt='SGMR Pharma' />
    </div>
  )
}

export default Logo